<template>
  <div>
      <div class="outline loginBox w3-white w3-margin-bottom">
        <div class="w3-padding dark headerGrid">
          <header>
            <h5 style="margin:0; line-height:34.4px;">Client Signup</h5>
          </header>
          <div>
            <button class="w3-button w3-light-grey w3-right" style="padding:6px 16px;" @click="state.view = 'loginView'">Back to Login</button>
          </div>
        </div>
        <div class="w3-container">
          <form class="w3-margin-top w3-margin-bottom" @submit.prevent="register">
            <label>
              <b>Email *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black w3-margin-bottom" type="email" v-model="registerData.email" v-bind:class="{ 'w3-border-green': registerData.email.match(/\S+@\S+\.\S+/) }" placeholder="Email" @keyup="validateEmail()">
            <template v-if="!emailDecent">
              <div class="w3-panel w3-text-red">Please enter a valid email address</div>
            </template>
            <label>
              <b>Password *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="password" v-model="registerData.password" v-bind:class="{ 'w3-border-green': registerData.password && metRequirements.pass1 }" placeholder="Enter Password" @keyup="passwordCheck()">
            <template v-if="!metRequirements.lowercase">
              <div class="w3-panel w3-text-red">Must Contain at least 1 Lowercase Character</div>
            </template>
            <template v-if="!metRequirements.uppercase">
              <div class="w3-panel w3-text-red">Must Contain at least 1 Uppercase Character</div>
            </template>
            <template v-if="!metRequirements.number">
              <div class="w3-panel w3-text-red">Must Contain at least 1 Number</div>
            </template>
            <template v-if="!metRequirements.special">
              <div class="w3-panel w3-text-red">Must Contain at least 1 Special Character: ~ * ! @ $ # % _ + . ? : , { }</div>
            </template>
            <template v-if="!metRequirements.length">
              <div class="w3-panel w3-text-red">Password Must be between 9 and 16 Characters long</div>
            </template>
            <template v-if="!metRequirements.badChars">
              <div class="w3-panel w3-text-red">Password Cannot Contain Characters: ^ &amp; ( ) " | &lt; &gt; [ ] ; / </div>
            </template>

            <label>
              <b>Repeat Password *</b>
            </label>
            <input
              class="w3-input w3-border w3-hover-border-black"
              type="password"
              v-model="registerData.password2"
              v-bind:class="{ 'w3-border-green': this.registerData.password == this.registerData.password2 && this.registerData.password !== '' }"
              placeholder="Repeat Password"
              @keyup="matchPasswords()"
            >
            <template v-if="!metRequirements.match">
              <div class="w3-panel w3-text-red">Passwords do not match</div>
            </template>
            <label>
              <b>Name *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="registerData.displayName" v-bind:class="{ 'w3-border-green': this.registerData.displayName !== '' }" placeholder="Your Name">
            <label>
              <b>Phone *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="number" v-model="registerData.phone" v-bind:class="{ 'w3-border-green': this.registerData.phone !== '' }" placeholder="1234567890">
            <label>
              <b>Company Name *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="registerData.businessName" v-bind:class="{ 'w3-border-green': this.registerData.businessName !== '' }" placeholder="Company Name">
            <label>
              <b>Address 1 *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="registerData.address.address1" v-bind:class="{ 'w3-border-green': this.registerData.address.address1 !== '' }" placeholder="Street Address">
            <label>
              <b>Address 2</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="registerData.address.address2" v-bind:class="{ 'w3-border-green': this.registerData.address.address2 !== '' }" placeholder="Address Line 2">
            <label>
              <b>City *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="registerData.address.city" v-bind:class="{ 'w3-border-green': this.registerData.address.city !== '' }" placeholder="City">
            <label>
              <b>State *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="registerData.address.state" v-bind:class="{ 'w3-border-green': this.registerData.address.state !== '' }" placeholder="State">
            <label>
              <b>Postal Code *</b>
            </label>
            <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="registerData.address.zip" v-bind:class="{ 'w3-border-green': this.registerData.address.zip !== '' && this.registerData.address.zip.match(/[0-9]/g)}" placeholder="Postal Code">

            <button class="w3-btn w3-btn-block w3-green w3-margin-top">Signup</button>
            <div class="w3-right">
              <div class="w3-margin-top" v-if="error !== ''">
                <span class="w3-text-red">{{error}}</span>
              </div>
            </div>
          </form>
        </div>
      </div>
  </div>
</template>

<script>
var dataStore = require('../dataStore').default

export default {
  name: 'register',
  data() {
    return {
      state: dataStore.state,
      registerData: {
        email: '',
        password: '',
        password2: '',
        displayName: '',
        businessName: '',
        phone: '',
        address: {
          address1: '',
          address2: '',
          city: '',
          state: '',
          zip: ''
        },
        status: 'new'
      },
      metRequirements: {
        lowercase: true,
        uppercase: true,
        number: true,
        special: true,
        length: true,
        badChars: true,
        match: true,
        pass1: true
      },
      emailDecent: true,
      newPassword: null,
      error: ''
    }
  },
  methods: {
    register() {
      this.formValidation().then(result => {
        if (result === 'success') {
          dataStore.registerUser(this.registerData).then(result => {
            if (result === 'success') {
              if (this.state.user.status === 'new') {
                this.state.view = 'verifyEmailView'
                this.$router.push('/')
              } else if (this.state.user.status === 'active') {
                this.state.view = 'userView'
                this.$router.push('/')
              } else {
                // TODO: status is something other than active or new?
              }
            } else {
              console.log(result)
            }
          })
        } else {
          // form validation fails
        }
      })
    },
    formValidation() {
      return new Promise(resolve => {
        if (this.registerData.email !== '' && this.registerData.email.match(/\S+@\S+\.\S+/)) {
          // console.log('email ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('email bad')
          return
        }
        if (this.registerData.password !== '' && this.metRequirements.pass1 && (this.registerData.password === this.registerData.password2)) {
          // console.log('passwords ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('passwords bad')
          return
        }
        if (this.registerData.displayName !== '') {
          // console.log('name ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('name bad')
          return
        }
        if (this.registerData.phone !== '') {
          // console.log('phone ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('phone bad')
          return
        }
        if (this.registerData.businessName !== '') {
          // console.log('businessName ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('businessName bad')
          // return;
        }
        if (this.registerData.address.address1 !== '') {
          // console.log('address1 ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('address1 bad')
          return
        }
        if (this.registerData.address.city !== '') {
          // console.log('city ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('city bad')
          return
        }
        if (this.registerData.address.state !== '') {
          // console.log('state ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('state bad')
          return
        }
        if (this.registerData.address.zip !== '') {
          // console.log('zip ok')
        } else {
          this.error = 'Please fill in all fields'
          console.log('zip bad')
          return
        }
        resolve('success')
      })
    },
    validateEmail() {
      if (this.registerData.email.match(/\S+@\S+\.\S+/)) {
        this.emailDecent = true
      } else {
        this.emailDecent = false
      }
    },
    passwordCheck() {
      var pw = this.registerData.password
      // Validate lowercase letters
      var lowerCaseLetters = /[a-z]/g
      if (pw.match(lowerCaseLetters)) {
        this.metRequirements.lowercase = true
      } else {
        this.metRequirements.lowercase = false
      }
      // Validate capital letters
      var upperCaseLetters = /[A-Z]/g
      if (pw.match(upperCaseLetters)) {
        this.metRequirements.uppercase = true
      } else {
        this.metRequirements.uppercase = false
      }
      // Validate numbers
      var numbers = /[0-9]/g
      if (pw.match(numbers)) {
        this.metRequirements.number = true
      } else {
        this.metRequirements.number = false
      }
      // Validate length
      if (pw.length >= 9 && pw.length <= 16) {
        this.metRequirements.length = true
      } else {
        this.metRequirements.length = false
      }
      // Check Special Chars
      var specialChars = /[~*!@$#%_+.?:,{}]/g
      if (pw.match(specialChars)) {
        this.metRequirements.special = true
      } else {
        this.metRequirements.special = false
      }
      // Check Bad Chars
      var badChars = /[\^&()|\[\]";<>\/]/g
      if (pw.match(badChars)) {
        this.metRequirements.badChars = false
      } else {
        this.metRequirements.badChars = true
      }
      // Validate All
      if (pw.match(lowerCaseLetters) && pw.match(upperCaseLetters) && pw.match(numbers) && pw.length >= 9 && pw.length <= 16 && pw.match(specialChars) && !pw.match(badChars)) {
        console.log('all win')
        this.metRequirements.pass1 = true
      }
    },
    matchPasswords() {
      if (this.registerData.password === this.registerData.password2 && this.registerData.password !== '') {
        this.metRequirements.match = true
      } else {
        this.metRequirements.match = false
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/register.vue